import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { useComponent } from '../../../../hooks/useComponent';
import useFormatBody from '../../../../utils/format-body';
import CardWrapper from '../../../common/Card/CardWrapper';
import CTAsList from '../../../common/CTAsList';
import Icon from '../../../common/Icon';
import ContentfulImage from '../../../common/Image';
import { CTAsContainer, DefaultCard, DefaultTileBody, DefaultTileContent, IconTitleContainer, } from './styles';
const DefaultTile = (props) => {
    var _a;
    const { isWide, entryId, componentType } = props;
    const item = useComponent(entryId, componentType);
    const theme = useTheme();
    const { CTAs, backgroundColor, title, richTitle, body, bodyLong, icon, image, } = (_a = item === null || item === void 0 ? void 0 : item.fields) !== null && _a !== void 0 ? _a : {};
    const mainCTA = useMemo(() => CTAs === null || CTAs === void 0 ? void 0 : CTAs[0].fields, [CTAs]);
    const background = useMemo(() => {
        return !!backgroundColor && backgroundColor !== 'transparent'
            ? theme.colors[backgroundColor]
            : undefined;
    }, [backgroundColor, theme.colors]);
    const titleContent = useFormatBody({ body: title, bodyLong: richTitle });
    const bodyContent = useFormatBody({ body, bodyLong });
    return (_jsx(CardWrapper, { link: mainCTA, children: _jsx(DefaultCard, { "$isWide": isWide, backgroundColor: background, hoverable: !!mainCTA, children: _jsxs(DefaultTileContent, { children: [_jsxs(DefaultTileBody, { children: [_jsxs(IconTitleContainer, { children: [!!icon ? (_jsx(Icon, Object.assign({}, icon.fields))) : (!!image && _jsx(ContentfulImage, { loading: "lazy", asset: image })), !!titleContent && (_jsx(Typography.Title, { level: 3, elementTheme: "h5", noMargin: true, children: titleContent }))] }), !!bodyContent && (_jsx(Typography, { elementTheme: "body2", color: theme.colors.grey_2, children: bodyContent }))] }), _jsx(CTAsContainer, { children: _jsx(CTAsList, { CTAs: CTAs === null || CTAs === void 0 ? void 0 : CTAs.map((cta) => cta.fields), nested: true }) })] }) }) }));
};
export default DefaultTile;
